<template>
     <svg
        width="16"
        height="16"
        viewBox="0 0 16 16"
        fill="none"
        xmlns="http://www.w3.org/2000/svg"
    >
        <path
        d="M7.99999 11C10.1974 11 12.119 11.9451 13.1643 13.3548L12.0591 13.8776C11.2084 12.8694 9.70843 12.2 7.99999 12.2C6.29154 12.2 4.79156 12.8694 3.94093 13.8776L2.83618 13.3543C3.88151 11.9448 5.80283 11 7.99999 11ZM7.99999 2C9.65683 2 11 3.34315 11 5V6.8C11 8.45684 9.65683 9.8 7.99999 9.8C6.34313 9.8 4.99999 8.45684 4.99999 6.8V5C4.99999 3.34315 6.34313 2 7.99999 2Z"
        :fill="iconColor"
        />
    </svg>
</template>
<script setup>
import { defineProps, inject } from 'vue';

 const $filters = inject('$filters');

const props = defineProps({
  color: {
    type: String,
    default: null,
  },
});


 const iconColor = props.color || $filters.iconColor() ||  'rgb(var(--locumate-primary-color))';
</script>
